
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.996","height":"17.996"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-log-out","fill":"none","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"패스 679","d":"M6.332 17H2.777A1.777 1.777 0 011 15.218V2.777A1.777 1.777 0 012.777 1h3.555"}}),_c('path',{attrs:{"data-name":"패스 680","d":"M12.552 13.442l4.443-4.443-4.443-4.444"}}),_c('path',{attrs:{"data-name":"패스 681","d":"M16.996 8.998H6.332"}})])])
          )
        }
      }
    